import { c as _c } from "react/compiler-runtime";
import { twMerge } from 'tailwind-merge';
type Props = {
  checked?: boolean;
  className?: string;
  label: string | React.ReactNode;
  value?: string | number | null | undefined;
  disabled?: boolean;
  onChange: (val: boolean) => void;
} & Omit<React.ComponentPropsWithoutRef<'input'>, 'onChange'>;
export function Checkbox(t0) {
  const $ = _c(37);
  let checked;
  let disabled;
  let id;
  let label;
  let name;
  let onChange;
  let rest;
  if ($[0] !== t0) {
    ({
      id,
      name,
      label,
      checked,
      onChange,
      disabled,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = checked;
    $[2] = disabled;
    $[3] = id;
    $[4] = label;
    $[5] = name;
    $[6] = onChange;
    $[7] = rest;
  } else {
    checked = $[1];
    disabled = $[2];
    id = $[3];
    label = $[4];
    name = $[5];
    onChange = $[6];
    rest = $[7];
  }
  const inputId = id || name;
  const t1 = disabled && "opacity-30";
  let t2;
  if ($[8] !== t1) {
    t2 = twMerge("flex w-full items-start py-1", t1);
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const t3 = disabled ? "cursor-not-allowed" : "hover:cursor-pointer";
  let t4;
  if ($[10] !== t3) {
    t4 = twMerge("flex h-6 shrink-0 items-center", t3);
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== onChange) {
    t5 = e => onChange(e.target.checked);
    $[12] = onChange;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== checked || $[15] !== disabled || $[16] !== inputId || $[17] !== name || $[18] !== rest || $[19] !== t5) {
    t6 = <input id={inputId} name={name} type="checkbox" className="form-checkbox" checked={checked} disabled={disabled} onChange={t5} {...rest} />;
    $[14] = checked;
    $[15] = disabled;
    $[16] = inputId;
    $[17] = name;
    $[18] = rest;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <svg fill="none" viewBox="0 0 14 14" className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25" aria-hidden="true"><path d="M3 8L6 11L11 3.5" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="opacity-0 group-has-checked:opacity-100" /><path d="M3 7H11" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="opacity-0 group-has-indeterminate:opacity-100" /></svg>;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t6) {
    t8 = <div className="group grid size-4 grid-cols-1">{t6}{t7}</div>;
    $[22] = t6;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t4 || $[25] !== t8) {
    t9 = <div className={t4}>{t8}</div>;
    $[24] = t4;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  const t10 = disabled ? "cursor-not-allowed" : "cursor-pointer";
  let t11;
  if ($[27] !== t10) {
    t11 = twMerge("form-inline-label mt-0.5 pl-2.5", t10);
    $[27] = t10;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== inputId || $[30] !== label || $[31] !== t11) {
    t12 = <label htmlFor={inputId} className={t11}>{label}</label>;
    $[29] = inputId;
    $[30] = label;
    $[31] = t11;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== t12 || $[34] !== t2 || $[35] !== t9) {
    t13 = <div className={t2}>{t9}{t12}</div>;
    $[33] = t12;
    $[34] = t2;
    $[35] = t9;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  return t13;
}